module.exports = __webpack_public_path__ + "img/certificate6.6e826584.png";